import { Box, Tabs } from "@mantine/core";
import AppNavbar from "../../../components/AppNavbar/AppNavbar";
import { useSelector } from "react-redux";
import useStyles from "./style";
import ProspectPipeline from "../../../components/ProspectPipeline";
import { useEffect, useState } from "react";
import { getAllSkypointProspectsStatus } from "../../../services/skypointProspect";

const Prospect = () => {
  const { profile } = useSelector((state) => state?.profile);
  const { classes } = useStyles();
  const [activeTab, setActiveTab] = useState("pipeline");
  const [activeFilter, setActiveFilter] = useState("All");
  const [currentPage, setCurrentPage] = useState(1);
  const [sortBy, setSortBy] = useState("newest");
  const [searchQuery, setSearchQuery] = useState("");

  const getALl = async () => await getAllSkypointProspectsStatus();
  useEffect(() => {
    getALl();
  }, []);
  const handleTabChange = (v) => {
    setActiveFilter("All");
    setCurrentPage(1);
    setSortBy("newest");
    setSearchQuery("");
    setActiveTab(v);
  };

  return (
    <Box className={classes.content}>
      <AppNavbar title="Providers" profile={profile} />
      <Box className={classes.contentWrapper}>
        <Tabs
          value={activeTab}
          onTabChange={handleTabChange}
          className={classes.tabs}
          keepMounted={false}
        >
          <Tabs.List>
            <Tabs.Tab value="pipeline">Pipeline</Tabs.Tab>
            <Tabs.Tab value="closed">Closed</Tabs.Tab>
            {/* <Tabs.Tab value="settings">Settings</Tabs.Tab> */}
          </Tabs.List>
          <Tabs.Panel value="pipeline">
            <ProspectPipeline
              activeTab={activeTab}
              activeFilter={activeFilter}
              setActiveFilter={setActiveFilter}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              sortBy={sortBy}
              setSortBy={setSortBy}
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
            />
          </Tabs.Panel>
          <Tabs.Panel value="closed">
            <ProspectPipeline
              activeTab={activeTab}
              activeFilter={activeFilter}
              setActiveFilter={setActiveFilter}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              sortBy={sortBy}
              setSortBy={setSortBy}
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
            />
          </Tabs.Panel>
          <Tabs.Panel value="settings"></Tabs.Panel>
        </Tabs>
      </Box>
    </Box>
  );
};

export default Prospect;
